(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caeli-storefront-fixes"]) return;
  try {
    
(function () {
  function hideEmptyReviewBadges() {
    var badges = document.querySelectorAll('.jdgm-preview-badge, .jdgm-prev-badge');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      var count = b.getAttribute('data-number-of-reviews');
      var txt = (b.textContent || '').trim().toLowerCase();
      if (count === '0' || txt === 'no reviews') {
        var wrap = b.closest ? b.closest('.caeli-review-badge') : null;
        if (wrap) { wrap.classList.add('caeli-badge-empty'); }
        else { b.style.display = 'none'; }
      }
    }
  }

  function syncStickyCta() {
    var sticky = document.querySelector('.caeli-sticky-cta');
    var mainBtn = document.querySelector('.caeli-add-to-cart-btn');
    var barOn = false;
    if (sticky && mainBtn) {
      var r = mainBtn.getBoundingClientRect();
      var show = window.innerWidth <= 1024 && r.bottom < 0;
      if (show) { sticky.classList.add('caeli-sticky-forced'); }
      else { sticky.classList.remove('caeli-sticky-forced'); }
      barOn = show;
    }
    var cartBar = document.getElementById('caeli-sticky-checkout');
    if (cartBar && !cartBar.hidden) { barOn = true; }
    document.documentElement.classList.toggle('caeli-bar-on', barOn);
  }

  function readPick() {
    try { return JSON.parse(localStorage.getItem('caeli_gift_pick') || 'null'); } catch (e) { return null; }
  }

  function applyPick(pick) {
    if (!pick || !pick.variant) { return; }
    var plural = (pick.title || '').slice(-1).toLowerCase() === 's';
    var sizeHtml = pick.size ? ' <span>size ' + pick.size + '</span>' : '';
    var nudge = document.querySelector('.caeli-cart-nudge');
    if (nudge) {
      var input = nudge.querySelector('input[name=id][value="' + pick.variant + '"]');
      var text = nudge.querySelector('.caeli-cart-nudge__text');
      if (input) {
        var f = input.closest('form');
        var b = f.querySelector('button');
        b.classList.add('is-pick');
        b.innerHTML = 'Add your ' + pick.title + sizeHtml;
        f.parentNode.insertBefore(f, f.parentNode.firstChild);
        if (text) { text.textContent = 'You picked the ' + pick.title + '. ' + (plural ? 'Add them and they come' : 'Add it and it comes') + ' off at checkout, no code.'; }
      } else if (text && text.textContent.indexOf('away') > -1) {
        text.insertAdjacentText('afterbegin', 'Your ' + pick.title + (plural ? ' are' : ' is') + ' held. ');
      }
    }
    var picks = document.querySelectorAll('.cfg-pick');
    for (var i = 0; i < picks.length; i++) {
      var href = picks[i].getAttribute('href') || '';
      var mine = href.indexOf(':1,' + pick.variant + ':1') > -1 || href.indexOf('/' + pick.handle) > -1;
      picks[i].classList.toggle('is-pick', mine);
      if (mine && !picks[i].querySelector('.cfg-pick-flag')) {
        var flag = document.createElement('p');
        flag.className = 'cfg-pick-flag';
        flag.textContent = 'Your pick';
        picks[i].insertBefore(flag, picks[i].firstChild);
      }
    }
  }

  window.addEventListener('scroll', syncStickyCta, { passive: true });
  window.addEventListener('resize', syncStickyCta);
  document.addEventListener('caeli:gift-pick', function (e) { applyPick(e.detail); });

  function init() {
    hideEmptyReviewBadges();
    syncStickyCta();
    applyPick(readPick());
    var tries = 0;
    var poll = setInterval(function () {
      hideEmptyReviewBadges();
      syncStickyCta();
      if (++tries > 12) { clearInterval(poll); }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
